import {oldApi} from '../app/oldApi';
import store from '../store';
import {app} from '../main';
import User from '../../../shared/entities/User';

export const sessionService = {
	async loadSession() {
		let { data: user } = await oldApi.get('Auth.GetUser');

		store.commit('setSession', user ? new User(user) : null);

		if (user && user.Id) {
			app.$ga.set({
				userId: user.Id,
				premium: !!user.Status
			});
		} else {
			app.$ga.set({
				premium: false
			});
		}

		return user;
	}
};